export const schedulerMenuDef = [
    {
        name: 'Scheduler Master',
        resource: 'scheduler_master',
        icon: 'fa fa-plus-square',
        url: 'scheduler_master',
        auto_crud: true,
        breadcrumb: 'All Schedulers',
        showMenu: true
    },
    {
        name: 'Schedulers',
        resource: 'custom_scheduler',
        icon: 'fa fa-plus-square',
        url: 'custom_scheduler',
        auto_crud: true,
        breadcrumb: 'All Schedulers',
        showMenu: true
    },
    {
        name: 'Copy Schedulers',
        resource: 'scheduler_copy',
        icon: 'fa fa-plus-square',
        url: 'scheduler_copy',
        auto_crud: true,
        breadcrumb: 'Copy Schedulers',
        showMenu: true
    }
]